import {Modal} from 'flowbite-react';
import Button from "../components/buttons/Button"
import PropTypes from "prop-types";

function ModalInspection(props) {
  const {show, onClose, renderContent} = props;
  return (
    <Modal show={show} onClose={onClose}>
      <Modal.Header>
        備考
      </Modal.Header>
      <Modal.Body className="2xl:p-6 xl:p-5 md:p-4">
        {renderContent && renderContent()}
      </Modal.Body>
      <Modal.Footer className="flex">
        <div className="flex-1"></div>
        <Button color="gray" className="min-w-[80px]" children="閉じる" onClick={onClose} />
      </Modal.Footer>
    </Modal>
  );
}

export default ModalInspection;

ModalInspection.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  renderContent: PropTypes.func,
};
